<template>
<div class="chapter">
<div class="inner_page">
<a id="page_v"></a>
<h1 class="toc-title">Contents</h1>
<h2 class="tocb"><a href="#/xhtml/05_Foreword"><em class="italic">Foreword</em></a></h2>
<h2 class="toc2"><a href="#/xhtml/06_Chapter01"><span class="bold"><span class="space">Chapter 1</span></span> The Sources, History, and Criticism</a></h2>
<h2 class="toc2"><a href="#/xhtml/07_Chapter02"><span class="bold"><span class="space">Chapter 2</span></span> Activating the 614th Tank Destroyer Battalion</a></h2>
<h2 class="toc2"><span href="#/xhtml/08_Chapter03" title="Link target outside of Sample"><span class="bold"><span class="space">Chapter 3</span></span> The 614th Tank Destroyer Battalion</span></h2>
<h2 class="toc2"><span href="#/xhtml/09_Chapter04" title="Link target outside of Sample"><span class="bold"><span class="space">Chapter 4</span></span> Three-inch Fury</span></h2>
<h2 class="toc2"><span href="#/xhtml/10_Chapter05" title="Link target outside of Sample"><span class="bold"><span class="space">Chapter 5</span></span> Getting out of the Northern Wind</span></h2>
<h2 class="toc2"><span href="#/xhtml/11_Chapter06" title="Link target outside of Sample"><span class="bold"><span class="space">Chapter 6</span></span> Fighting and Resting</span></h2>
<h2 class="toc2"><span href="#/xhtml/12_Chapter07" title="Link target outside of Sample"><span class="bold"><span class="space">Chapter 7</span></span> Racing through the Alps</span></h2>
<h2 class="toc2"><span href="#/xhtml/13_Chapter08" title="Link target outside of Sample"><span class="bold"><span class="space">Chapter 8</span></span> The 827th and the 679th Tank Destroyer Battalion</span></h2>
<h2 class="toc2"><span href="#/xhtml/14_Chapter09" title="Link target outside of Sample"><span class="bold"><span class="space">Chapter 9</span></span> The Dusk of the Tank Destroyers</span></h2>
<h2 class="toc3"><span href="#/xhtml/15_AppendixA" title="Link target outside of Sample"><span class="bold">Appendix A: List of men in the unit</span></span></h2>
<h2 class="toc3"><span href="#/xhtml/16_AppendixB" title="Link target outside of Sample"><span class="bold">Appendix B: List of casualties</span></span></h2>
<h2 class="toc3"><span href="#/xhtml/17_AppendixC" title="Link target outside of Sample"><span class="bold">Appendix C: Medals and citation</span></span></h2>
<h2 class="toct"><span href="#/xhtml/18_Literatureandsources" title="Link target outside of Sample"><em class="italic">Literature and sources</em></span></h2>
<h2 class="toc4"><span href="#/xhtml/19_Endnotes" title="Link target outside of Sample"><em class="italic">Endnotes</em></span></h2>
<a id="page_vi"></a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Toc.vue?5d7a143c